export default "__VITE_ASSET__8ycDqXA1__"